/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?d22584eb3d2ec239be004a0b';

u.use(UIBootstrap5);

export default u;

const searchInput = $('.js-search-input');
const searchForm = $('.js-search-form');

searchInput.on('change', function () {
  searchInput.val($(this).val());
});

searchInput.keydown(function(e) {
  if (String(e.keyCode) === '13') {
    searchInput.val($(this).val());
    searchForm.submit();
  }
});
